jQuery(document).ready(function() {
    if (jQuery("#splashScreen").length > -1) {
        if (jQuery(window).width() > 768) {
            setTimeout(function() {
                jQuery('#splashScreen').fadeOut();
                setCookie('loaded', true);
            }, 2000);
        } else {
            setTimeout(function() {
                jQuery('#splashScreen').fadeOut();
                setCookie('loaded', true);
            }, 3000);
        }
    }
});

// jQuery(window).on('load', function() {
//     if (getCookie('loaded')) {
//         jQuery('#splashScreen').hide();
//     }
// });

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}